module.exports = __webpack_public_path__ + "img/list-pattern3.9d91a92.svg";